/** Business unit constants shared across filter components. */

/** Row in ref_bu_sbu_project_codes for projects not mapped to a delivery BU. */
export const UNALLOCATED_BUSINESS_UNIT = 'Unallocated';

export const excludeUnallocatedFromBus = (bus: string[] | undefined): string[] =>
  (bus || []).filter((b) => b !== UNALLOCATED_BUSINESS_UNIT);
